var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"lg","title":"Movimientos entre Cajas","hide-footer":"","id":"movimientos-entre-cajas"}},[_c('view-component',{attrs:{"set_model_on_row_selected":false,"model_name":"movimiento_entre_caja"},on:{"modelSaved":_vm.modelSaved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }